import { ReactNode } from "react";

interface DetailsContainerProps {
  children?: ReactNode;
}

export function DetailsContainer({ children }: DetailsContainerProps) {
  return <div className="flex flex-col m-2 p-2">{children}</div>;
}
